import {
  DSButton,
  DSCol,
  DSIllustration,
  DSModal,
  DSRow,
  DSText
} from '@vr/ds-react'

const ModalRequestLogisticsSuccess = ({
  show = false,
  onClose = () => {}
}: {
  show?: boolean
  onClose?: () => void
}) => {
  return (
    <DSModal config={{ show, onClose }}>
      <DSModal.Header onClose={onClose}></DSModal.Header>
      <DSModal.Body
        css={{ textAlign: 'center', alignItems: 'center', gap: '$sm24' }}
      >
        <DSIllustration name='status-tracking' size={300} />
        <DSText variant='title' weight='bold'>
          Solicitação registrada
        </DSText>
        <DSText as='p'>
          Acompanhe o processo de logística através das abas{' '}
          <strong>Geral, Coletas e Entregas</strong>.
        </DSText>
      </DSModal.Body>
      <DSModal.Footer>
        <DSRow wrap='wrap' align='center'>
          <DSCol
            xs={12}
            lg={12}
            gap={4}
            style={{ display: 'flex' }}
            justify='center'
          >
            <DSButton variant='secondary' type='submit' onClick={onClose}>
              Fechar
            </DSButton>
          </DSCol>
        </DSRow>
      </DSModal.Footer>
    </DSModal>
  )
}

export default ModalRequestLogisticsSuccess
